import { KeyRound, RefreshCw, Building2, Home, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "./constants";

const SERVICES = [
  {
    icon: KeyRound,
    title: "Buying Your First Home",
    desc: "Step onto the ladder without the stress. I'll walk you through deposits, schemes and paperwork in plain English — and chase the approval for you.",
    chips: ["Deposit help", "Schemes explained", "Fast approval"],
    span: "lg:col-span-7",
  },
  {
    icon: RefreshCw,
    title: "Remortgaging",
    desc: "Coming to the end of a deal? I'll check the whole market and can secure a new rate up to 6 months before yours runs out.",
    chips: ["Switching deals", "Borrowing more"],
    span: "lg:col-span-5",
  },
  {
    icon: Building2,
    title: "Buy-to-Let & Landlords",
    desc: "Growing a portfolio or buying your first rental? I'll sort the right setup — including limited company options — so the numbers work.",
    chips: ["SPV structures", "Portfolio review"],
    span: "lg:col-span-5",
  },
  {
    icon: Home,
    title: "Moving Home",
    desc: "Chains, timings, porting your mortgage — moving is fiddly. I'll coordinate the lot so you don't lose the home you've fallen for.",
    chips: ["Chain management", "Porting explained", "Bridging options"],
    span: "lg:col-span-7",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-[#052B38]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl mb-14">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400/90 mb-5">
            How I Can Help
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
            However you're moving, I've got you.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className={s.span}>
              <div
                data-testid={`service-card-${i}`}
                className="group relative h-full rounded-3xl border border-white/10 bg-[#073B4C] p-8 lg:p-10 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40 hover:shadow-2xl hover:shadow-amber-500/5"
              >
                <div className="absolute -top-24 -right-24 h-56 w-56 rounded-full bg-amber-400/0 blur-3xl transition-colors duration-500 group-hover:bg-amber-400/10" />
                <div className="relative flex items-start justify-between">
                  <div className="h-12 w-12 rounded-2xl bg-amber-400/10 border border-amber-400/25 flex items-center justify-center">
                    <s.icon size={20} className="text-amber-400" />
                  </div>
                  <a
                    href={waLink(`Hi Kieran, I'd like a chat about: ${s.title}`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`service-card-cta-${i}`}
                    aria-label={`Ask about ${s.title} on WhatsApp`}
                    className="p-2 rounded-full border border-white/10 text-slate-400 opacity-0 group-hover:opacity-100 hover:text-amber-400 hover:border-amber-400/40 transition-all duration-300"
                  >
                    <ArrowUpRight size={16} />
                  </a>
                </div>
                <h3 className="relative mt-6 font-display text-xl sm:text-2xl font-medium text-white">
                  {s.title}
                </h3>
                <p className="relative mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">
                  {s.desc}
                </p>
                <div className="relative mt-6 flex flex-wrap gap-2">
                  {s.chips.map((c) => (
                    <span
                      key={c}
                      className="rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 font-mono text-[11px] tracking-wider uppercase text-slate-400"
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
